import { render, staticRenderFns } from "./edit-techprovider-form.vue?vue&type=template&id=afa80a9c&"
import script from "./edit-techprovider-form.vue?vue&type=script&lang=js&"
export * from "./edit-techprovider-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports